
(() => {
  const PROP = '_gift_timer';
  const KEY = 'sa_cart_gift';

  /* Версія правил. Стан у памʼяті браузера тримає позначки «час вийшов» і
     «знижку заблокувала інша акція» - і тримає їх довго, бо інакше покупець
     перезапускав би таймер або ганяв кошик по колу. Коли правила в магазині
     міняються (акцію Kite замінила наша функція), старі позначки стають
     брехнею: людина сиділа б без подарунка через конфлікт, якого вже немає.
     Тому стан зі старим номером просто не читаємо. */
  const RULES = 2;

  /* Через скільки позначка «час вийшов» перестає діяти. Кошик у Shopify живе
     тижнями, тож без цього покупець, у якого раз вибіг таймер, не побачив би
     подарунка ніколи - а це виглядає як поламаний сайт, а не як акція. */
  const FORGET = 24 * 60 * 60 * 1000;

  const pad = (n) => String(n).padStart(2, '0');

  const readState = () => {
    try { return JSON.parse(localStorage.getItem(KEY) || 'null') || null; } catch (e) { return null; }
  };
  const writeState = (v) => {
    try {
      if (v) localStorage.setItem(KEY, JSON.stringify(v));
      else localStorage.removeItem(KEY);
    } catch (e) {  }
  };

  /* Замок спільний на весь модуль, а не на елемент: дравер перемальовується
     з нуля після кожної зміни кошика, тож instance-прапорець не рятує -
     новий елемент не знає, що старий уже кладе подарунок, і клав другий. */
  let working = false;

  const giftLine = (cart) => {
    const items = (cart && cart.items) || [];
    for (let i = 0; i < items.length; i += 1) {
      if (items[i].properties && items[i].properties[PROP]) return { item: items[i], line: i + 1 };
    }
    return null;
  };

  /* Поріг рахуємо по ЦІНАХ ДО ЗНИЖОК, і ось чому.
     У магазині живе акція Kite «2=3»: вона ріже частину позицій до 0.10.
     Щойно ми кладемо подарунок (а це теж крем для рук), Kite перераховує
     свою акцію на інший набір позицій - сума «після знижок» стрибає, поріг
     то береться, то ні, і подарунок блимає. Ціни ДО знижок від появи
     подарунка не залежать, тож вимір стабільний за будь-яких акцій. */
  const paidSubtotal = (cart) =>
    ((cart && cart.items) || [])
      .filter((it) => !(it.properties && it.properties[PROP]))
      .reduce((n, it) => n + (it.original_line_price || it.final_line_price), 0);

  class CartGiftTimer extends HTMLElement {
    connectedCallback() {
      this.variantId = Number(this.dataset.variant);
      this.minCents = Number(this.dataset.minCents) || 0;
      this.minutes = Number(this.dataset.minutes) || 10;
      this.currency = this.dataset.currency || '';
      this.giftCents = Number(this.dataset.giftCents) || 10;
      this.cell = this.querySelector('[data-gift-countdown]');
      this.busy = false;

      this.unsubscribe = window.PubSub?.subscribe(window.EVENTS?.cartUpdate, ({ cart }) => {
        if (cart) this.sync(cart);
      });

      window.CartAPI?.get().then((cart) => this.sync(cart)).catch(() => {  });
    }

    disconnectedCallback() {
      this.unsubscribe?.();
      clearInterval(this.ticker);
    }

    /** Стан у localStorage прив'язаний до кошика: інший кошик - інший відлік. */
    stateFor(cart) {
      const st = readState();
      if (!st || st.v !== RULES) return null;
      if (st.token !== cart.token || st.variant !== this.variantId) return null;
      return st;
    }

    sync(cart) {
      if (!this.minCents || !this.variantId) return this.off();

      /* Порожній кошик - нові покупки, отже і нова спроба. Інакше позначка
         «час вийшов» тягнулася б за людиною, доки живий кошик. */
      if (!cart.item_count) {
        writeState(null);
        return this.off();
      }

      const paid = paidSubtotal(cart);
      const has = giftLine(cart);
      const qualified = paid >= this.minCents;
      let st = this.stateFor(cart);

      if (!qualified) {
        /* Опустилися нижче порога: відлік обнуляється, наступного разу
           почнеться заново. А ось позначку «час вийшов» лишаємо: інакше
           вистачило б прибрати товар і повернути, щоб дістати нові 10 хвилин.
           Один кошик - одна спроба; новий кошик - нова. */
        if (st) writeState(st.expired ? { ...st, ends: 0 } : null);
        if (has) this.drop(has.line);
        return this.off();
      }

      /* Позначки «час вийшов» і «заблоковано» з минулої доби вже не наші:
         відпускаємо і починаємо заново. */
      if (st && (st.expired || st.blocked) && Date.now() - (st.ends || 0) > FORGET) {
        writeState(null);
        st = null;
      }

      /* Час вийшов. Подарунок тут бути не може: якщо він лишився (вкладку
         закрили в мить, коли ми його знімали, або запит не дійшов), знімаємо
         зараз. Функція знижки годинника не має і віддала б його за 0.10. */
      if (st && st.expired) {
        if (has) this.drop(has.line);
        return this.off();
      }

      /* Знижку заблокувала інша акція - див. `blocked` нижче. */
      if (st && st.blocked) {
        if (has) this.drop(has.line);
        return this.off();
      }

      if (!st) {
        st = {
          v: RULES,
          token: cart.token,
          variant: this.variantId,
          ends: Date.now() + this.minutes * 60000,
        };
        writeState(st);
      }

      if (st.ends - Date.now() <= 0) {
        writeState({ ...st, expired: true });
        if (has) this.drop(has.line);
        return this.off();
      }

      /* Поки подарунка в кошику немає - плашки теж немає. Ціни в ній малює
         Liquid із ПОТОЧНОГО кошика, тож показана зараз вона написала б
         «10 €» замість «0,10 €», а за секунду дравер перемалювався б і
         показав її вдруге, вже правильно. Власник це й побачив: плашка
         зʼявилась, зникла, зʼявилась. Чекаємо на перемальовку. */
      if (!has) {
        this.put();
        return this.off();
      }

      if (has.item.quantity > 1) {
        this.trim(has.line);
        return this.off();
      }

      if (!this.priced(has.item)) {
        /* Подарунок у кошику, але знижка на нього не лягла - у магазині є
           акція, яка не комбінується з товарними знижками (наприклад код
           Mood7). Тримати в кошику «подарунок» за повну ціну не можна:
           знімаємо і більше не пробуємо, інакше вийде нескінченне коло
           «поклали - прибрали». */
        writeState({ ...st, blocked: true });
        this.drop(has.line);
        return this.off();
      }

      this.ends = st.ends;
      this.on();
    }

    /* Чи справді подарунок коштує те, що обіцяли. Беремо з запасом у 1 цент
       на округлення валют. */
    priced(item) {
      const target = Math.round(this.giftCents * item.quantity);
      return item.final_line_price <= target + 1;
    }

    on() {
      this.hidden = false;
      clearInterval(this.ticker);
      this.tick();
      this.ticker = setInterval(() => this.tick(), 1000);
    }

    off() {
      this.hidden = true;
      clearInterval(this.ticker);
    }

    tick() {
      const left = this.ends - Date.now();
      if (left <= 0) {
        clearInterval(this.ticker);
        const st = readState();
        if (st) writeState({ ...st, expired: true });
        window.CartAPI?.get().then((cart) => {
          const has = giftLine(cart);
          if (has) this.drop(has.line);
        }).catch(() => {  });
        return this.off();
      }
      const s = Math.floor(left / 1000);
      if (this.cell) this.cell.textContent = `${pad(Math.floor(s / 60))}:${pad(s % 60)}`;
    }

    async put() {
      if (working) return;
      working = true;
      try {
        await window.CartAPI.add(
          [{ id: this.variantId, quantity: 1, properties: { [PROP]: '1' } }],
          { source: 'cart-gift-timer' },
        );
      } catch (e) {  } finally {
        working = false;
      }
    }

    async trim(line) {
      if (working || !line) return;
      working = true;
      try {
        await window.CartAPI.change({ line, quantity: 1 }, { source: 'cart-gift-timer' });
      } catch (e) {  } finally {
        working = false;
      }
    }

    async drop(line) {
      if (working || !line) return;
      working = true;
      try {
        await window.CartAPI.change({ line, quantity: 0 }, { source: 'cart-gift-timer' });
      } catch (e) {  } finally {
        working = false;
      }
    }
  }

  if (!customElements.get('cart-gift-timer')) customElements.define('cart-gift-timer', CartGiftTimer);
})();
